import React from 'react';
import cn from '../../../../lib/bem';
import ico_asesor from './../../../../assets/icons/ico_asesor.svg';
import ButtonComponent from '../../../../components/button/button_component';
import HeaderComponent from '../../../../components/header/header_component';
import {CONTENT_PAG} from '../../constants/content_pag';

import './consuReinversion.scss';

const ConsuReinversion = ({mostrarPagConsultaRescate}) => {
  
    const classes = cn("ConsuReinversion");

    const onClickAcpetar = () => {
        mostrarPagConsultaRescate(CONTENT_PAG.PAG_MENS);
    }

    return (
        <div className={classes()}>
            <HeaderComponent flagHeaderMobile={false} index={false} title={"Consulta de Rescate"}/>
            <div className={classes('consuReinversionDiv')}>
                <div>
                    <img src={ico_asesor} alt='asesor' />
                </div>
                <br/>
                <div>
                    <p><b>Gracias por confiar en nosotros</b></p>
                </div>
                <div className={classes('consuReinversionMensaje')}>
                    <p>Te agradecemos por confiar en nosotros. Por favor, en caso de reinversi&oacute;n contacta con tu asesor.</p>
                    <p>Cualquier duda o consulta puedes llamar a nuestra cental al n&uacute;mero <a className={classes('linkTel')} href="tel:015135000">(01) 513 5000</a>.</p>
                </div>
                <div className={classes('consuReinversionButton')}>
                    <ButtonComponent label={'btnAceptar'} nombre={ 'Aceptar' } tipo={'button-red'} action={() => onClickAcpetar()} disabled={false}/>
                </div>
            </div>
        </div>
    );
}



export default ConsuReinversion;
